import { AbsoluteNumberInput, FloatNumberInput } from '@/components';
import { TableCell, TableRow } from '@/components/ui/table';
import { AbsatzVorgabe } from '@/domain/controlling/entities';
import { useTranslation } from 'react-i18next';
import { AbsoluteNumberField, ZielstundenField } from '../../../components';
import { PrognoseUebernehmenButton } from './PrognoseUebernehmenButton';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { useDialogContext } from '../DialogContext';
import { useState } from 'react';
import { calculatAbsatzZielminuten } from './calculateZielminuten';
import { maskitoParseNumber } from '@maskito/kit';
import { useStandortContext } from '@/features/standortContext/StandortContext';

// eslint-disable-next-line max-lines-per-function
export function AbsatzPlanWerteTableRow() {
  const { t } = useTranslation();
  const { dispatch, planwerteForm } = useDialogContext();
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { tagebuchEinstellungen } = useTagebuchEinstellungen(standortId);
  const { absatzVorgabe } = tagebuchEinstellungen.absatzProduktivitaet;

  function handleUpdateAbsatzPlanwert(value: string) {
    dispatch({
      type: 'updateAbsatzPlan',
      values: {
        absatzPlan: value,
      },
    });
  }

  function handleUpdateAbsatzProduktivitaet(value: string) {
    dispatch({
      type: 'updateAbsatzProduktivitaet',
      values: {
        absatzProduktivitaet: value,
      },
    });
  }

  const [zielstunden, setZielstunden] = useState<number | undefined>(
    planwerteForm.formValues.absatzZielminuten,
  );

  return (
    <TableRow className="hover:bg-transparent">
      <TableCell className="font-medium py-4 ps-0 w-1/4">
        <AbsoluteNumberInput
          value={planwerteForm.formValues.absatzPlan}
          onInput={(e) => {
            handleUpdateAbsatzPlanwert(e.currentTarget.value);
            const updatedZielstunden = calculatAbsatzZielminuten(
              maskitoParseNumber(e.currentTarget.value, ','),
              maskitoParseNumber(
                planwerteForm.formValues.absatzProduktivitaet,
                ',',
              ),
              absatzVorgabe,
            );
            setZielstunden(updatedZielstunden);
          }}
          unit={t('domain.controlling.umsatzplanung.units.stueck')}
        />
      </TableCell>
      <TableCell className="font-medium p-4 w-1/4">
        <div className="flex items-center -ms-3 gap-1">
          <PrognoseUebernehmenButton
            type="absatz"
            absatzPrognose={planwerteForm.formValues.absatzPrognose}
          />
          <AbsoluteNumberField
            value={planwerteForm.formValues.absatzPrognose}
            unit={t('domain.controlling.umsatzplanung.units.stueck')}
          />
        </div>
      </TableCell>
      <TableCell className="font-medium p-4 w-1/4">
        <FloatNumberInput
          value={planwerteForm.formValues.absatzProduktivitaet}
          onInput={(e) => {
            handleUpdateAbsatzProduktivitaet(e.currentTarget.value);
            const updatedZielstunden = calculatAbsatzZielminuten(
              maskitoParseNumber(planwerteForm.formValues.absatzPlan, ','),
              maskitoParseNumber(e.currentTarget.value, ','),
              absatzVorgabe,
            );
            setZielstunden(updatedZielstunden);
          }}
          unit={
            absatzVorgabe === AbsatzVorgabe.Stueck
              ? t('domain.controlling.umsatzplanung.ziele.Stk./Std.')
              : t('domain.controlling.umsatzplanung.ziele.mpt')
          }
        />
      </TableCell>
      <TableCell className="font-medium p-4 w-1/4">
        <ZielstundenField value={zielstunden} />
      </TableCell>
    </TableRow>
  );
}
